import { Navigate, useParams } from 'react-router-dom';

import { WATCH_HELP_PATH } from '../navigation/paths.js';
import { SharedScreen } from './ScreenChrome.jsx';
import { findWatchTopic } from './watchTopics.jsx';

// One Watch App help topic: the app's own screen for it, rendered in place inside
// the web shell, with its header's back link sent to the topic list. Keyed by the
// topic so moving between topics starts a stepped topic from its first step. A
// slug the app has no topic for goes back to the list.
export default function WatchHelpTopicScreen() {
  const { topic: slug } = useParams();
  const topic = findWatchTopic(slug);
  if (!topic) {
    return <Navigate to={WATCH_HELP_PATH} replace />;
  }
  const { Screen } = topic;
  return (
    <SharedScreen
      backTo={WATCH_HELP_PATH}
      backLabel="Watch App"
      className="watch-help"
    >
      <Screen key={topic.slug} />
    </SharedScreen>
  );
}
